export const LabelsQuery = `
  "label": {
    "copy": label.copy,
    "icon": label.icon->icon,
    "hexCode": label.hexCode
  }
`;
